import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { linkProfile } from "../../../../exports/wallets.js";
import { webLocalStorage } from "../../../../utils/storage/webStorage.js";
import { isEcosystemWallet } from "../../../../wallets/ecosystem/is-ecosystem-wallet.js";
import { hasStoredPasskey } from "../../../../wallets/in-app/web/lib/auth/passkeys.js";
import { iconSize } from "../../../core/design-system/index.js";
import { setLastAuthProvider } from "../../../core/utils/storage.js";
import { FingerPrintIcon } from "../../ui/ConnectWallet/icons/FingerPrintIcon.js";
import { Spacer } from "../../ui/components/Spacer.js";
import { Container, ModalHeader } from "../../ui/components/basic.js";
import { Button } from "../../ui/components/buttons.js";
import { ErrorState } from "./ErrorState.js";
import { LoadingScreen } from "./LoadingScreen.js";
import { LoadingState } from "./LoadingState.js";
// is passkey stored?
// - login
// else
// - show login or signup options
export function PassKeyLogin(props) {
    const { wallet, done, client, chain, size, locale } = props;
    const [screen, setScreen] = useState("loading");
    const triggered = useRef(false);
    useEffect(() => {
        if (triggered.current) {
            return;
        }
        triggered.current = true;
        hasStoredPasskey(client, isEcosystemWallet(wallet.id) ? wallet.id : undefined)
            .then((isStored) => {
            if (isStored) {
                setScreen("login");
            }
            else {
                setScreen("select");
            }
        })
            .catch(() => {
            setScreen("select");
        });
    }, [client, wallet.id]);
    return (_jsxs(Container, { animate: "fadein", fullHeight: true, flex: "column", children: [_jsx(Container, { p: "lg", children: _jsx(ModalHeader, { title: props.isLinking
                        ? locale.passkeys.linkPasskey
                        : locale.passkeys.title, onBack: props.onBack }) }), _jsx(Container, { px: size === "wide" ? "xxl" : "lg", expand: true, flex: "column", center: "y", children: _jsxs("div", { children: [screen === "loading" && (_jsxs(_Fragment, { children: [_jsx(LoadingScreen, {}), _jsx(Spacer, { y: "xxl" })] })), screen === "select" && (_jsx(SelectLoginMethod, { onSignin: () => {
                                setScreen("login");
                            }, onSignup: () => {
                                setScreen("signup");
                            } })), screen === "login" && (_jsx(LoginScreen, { wallet: wallet, client: client, done: done, onCreate: () => {
                                setScreen("signup");
                            }, chain: chain, isLinking: props.isLinking })), screen === "signup" && (_jsx(SignupScreen, { wallet: wallet, client: client, done: done, chain: chain, isLinking: props.isLinking }))] }) })] }));
}
function LoginScreen(props) {
    const { wallet, done, client, chain } = props;
    const [status, setStatus] = useState("loading");
    const [error, setError] = useState();
    async function login() {
        setStatus("loading");
        try {
            if (props.isLinking) {
                await linkProfile(wallet, {
                    strategy: "passkey",
                    type: "sign-in",
                }).catch((e) => {
                    setError(e.message);
                    throw e;
                });
            }
            else {
                await wallet.connect({
                    client: client,
                    strategy: "passkey",
                    type: "sign-in",
                    chain,
                });
                await setLastAuthProvider("passkey", webLocalStorage);
            }
            done();
        }
        catch {
            setStatus("error");
        }
    }
    const triggered = useRef(false);
    useEffect(() => {
        if (triggered.current) {
            return;
        }
        triggered.current = true;
        login();
    });
    if (status === "loading") {
        return (_jsx(LoadingState, { title: "Requesting Passkey", subtitle: "A pop-up prompt will appear to sign-in and verify your passkey", icon: _jsx(FingerPrintIcon, { size: iconSize.xxl }) }));
    }
    if (status === "error") {
        return (_jsxs(_Fragment, { children: [_jsx(ErrorState, { onTryAgain: login, title: error || "Failed to Login" }), _jsx(Spacer, { y: "sm" }), _jsx(Button, { variant: "outline", fullWidth: true, onClick: props.onCreate, children: "Create a new Passkey" }), _jsx(Spacer, { y: "lg" })] }));
    }
    return null;
}
function SignupScreen(props) {
    const { wallet, done, client, chain } = props;
    const [error, setError] = useState();
    const [status, setStatus] = useState("loading");
    async function signup() {
        setStatus("loading");
        try {
            if (props.isLinking) {
                await linkProfile(wallet, {
                    strategy: "passkey",
                    type: "sign-up",
                });
            }
            else {
                await wallet.connect({
                    client: client,
                    strategy: "passkey",
                    type: "sign-up",
                    chain,
                });
                await setLastAuthProvider("passkey", webLocalStorage);
            }
            done();
        }
        catch (e) {
            console.error(e);
            if (e instanceof Error) {
                setError(`Error creating passkey: ${e.message}`);
            }
            setStatus("error");
        }
    }
    const triggered = useRef(false);
    useEffect(() => {
        if (triggered.current) {
            return;
        }
        triggered.current = true;
        signup();
    });
    if (status === "loading") {
        return (_jsx(LoadingState, { title: "Creating Passkey", subtitle: "A pop-up prompt will appear to sign-in and verify your passkey", icon: _jsx(FingerPrintIcon, { size: iconSize.xxl }) }));
    }
    if (status === "error") {
        return (_jsxs(_Fragment, { children: [_jsx(ErrorState, { onTryAgain: signup, title: error || "Failed to create passkey" }), _jsx(Spacer, { y: "lg" })] }));
    }
    return null;
}
function SelectLoginMethod(props) {
    return (_jsxs(Container, { children: [_jsx(Spacer, { y: "xxl" }), _jsx(Container, { flex: "row", center: "x", color: "accentText", children: _jsx(FingerPrintIcon, { size: iconSize["4xl"] }) }), _jsx(Spacer, { y: "xl" }), _jsx(Spacer, { y: "xxl" }), _jsx(Button, { variant: "accent", onClick: props.onSignup, fullWidth: true, children: "Create a Passkey" }), _jsx(Spacer, { y: "sm" }), _jsx(Button, { variant: "outline", onClick: props.onSignin, fullWidth: true, children: "I have a Passkey" }), _jsx(Spacer, { y: "lg" })] }));
}
//# sourceMappingURL=PassKeyLogin.js.map